<template>
<div class="my-invoice-detail">
    <el-form :model="dataForm" ref="dataForm" label-position="top">
      <div v-if="dataForm.isFirstBill && !id" class="tips">为保证开票准确，首次开票，请仔细核对开票资料，建议上传开票盖章文件，方便开票员核对，<span class="font-primary" @click="doItNow">立即处理</span></div>
      <ab-title title="基础信息">
        <div style="padding: 20px 20px 0px 20px">
          <el-row :gutter="30">
            <el-col :span="6" v-if="id">
              <el-form-item label="申请单号">
                <el-input
                  size="mini"
                  v-model="dataForm.number"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="开票金额">
                <el-input
                  size="mini"
                  :value="$filters.formatMoney(dataForm.invoiceAmount)"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="税额">
                <el-input
                  size="mini"
                  :value="$filters.formatMoney(dataForm.tax)"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="税率">
                <el-input
                  size="mini"
                  :value="dataForm.taxRate ? dataForm.taxRate + '%' : ''"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </ab-title>
      <ab-title :title="id ? '银行信息' : '发票抬头'">
        <template #subTitle class="operat-btn" style="margin-top: 10px">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            :loading="btnLoading"
            @click="editInvoice"
            v-if="!id || dataForm.clientStatus === '01-1'"
            plain
            >{{ isEditInvoice ? "确定修改" : "编辑" }}</el-button
          >
        </template>
        <div style="padding: 20px 20px 0px 20px">
          <el-row :gutter="30">
            <el-col :span="8" v-if="!id">
              <el-form-item label="开票名称">
                <el-input
                  size="mini"
                  v-model="customerVo.billName"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="id">
              <el-form-item label="发票抬头">
                <el-input
                  size="mini"
                  v-model="customerVo.name"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="纳税人识别号">
                <el-input
                  size="mini"
                  v-model="customerVo.taxpayerCode"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="开户银行">
                <el-input
                  size="mini"
                  v-model="customerVo.billBank"
                  :disabled="!isEditInvoice"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8" v-if="!id">
              <el-form-item label="开户银行">
                <ab-diaSelect
                  is-search
                  data-type="table"
                  v-model="customerVo.billBank"
                  :disabled="!isEditInvoice"
                  @changeData="bankChange"
                  url="/bas/basBank/pageList"
                ></ab-diaSelect>
              </el-form-item>
            </el-col> -->

            <el-col :span="8">
              <el-form-item label="银行账号">
                <el-input
                  size="mini"
                  v-model="customerVo.billBankAcct"
                  :disabled="!isEditInvoice"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="联系电话">
                <el-input
                  size="mini"
                  v-model="customerVo.billTel"
                  :disabled="!isEditInvoice"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="开票地址" class="textarea-item">
                <el-input
                  type="textarea"
                  :autosize="{ maxRows: 2 }"
                  v-model="customerVo.billAddress"
                  :disabled="!isEditInvoice"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="收票地址">
                <el-input
                  size="mini"
                  v-model="customerVo.receiptInvoiceAddress"
                  :disabled="!isEditInvoice"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="收票联系人">
                <el-input
                  size="mini"
                  v-model="customerVo.receiptInvoicePerson"
                  :disabled="!isEditInvoice"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="收票联系电话">
                <el-input
                  size="mini"
                  v-model="customerVo.receiptInvoiceTel"
                  :disabled="!isEditInvoice"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </ab-title>

      <!-- <ab-title title=" ">
        <div slot="subTitle">
          <p style="color: #162232; font-weight: 600; font-size: 16px"><span style="color: red">*</span> 收票信息</p>
          </div>
        <div style="padding: 20px 20px 20px 20px">
          <el-input
            size="mini"
            v-model="dataForm.invoiceAddress"
            placeholder="请输入收票地址和联系人"
            :disabled="dataForm.clientStatus !== null && dataForm.clientStatus !== '01-1'"
          ></el-input>
        </div>
      </ab-title> -->

      <ab-title title="开票信息">
        <template #subTitle class="operat-btn" style="margin-top: 10px">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-button_export"
            :loading="btnLoading"
            @click="exportFile"
            plain
            >导出</el-button
          >
        </template>
        <div style="padding: 20px 20px 20px 20px">
          <ab-table
            stripe
            showOrder
            index-label="序号"
            indexWidth="50"
            maxHeight="226"
            :column-list="columns"
            :table-list="tableData"
            :dataListLoading="tableLoading"
            showSummary
            :summaryMethod="getSummaries"
          >
          </ab-table>
        </div>
      </ab-title>
     <div class="ab-file-upload2">
      <ab-upload2
        style="margin-top:8px"
        v-if="dataForm.invoiceType === 1"
        fileTitle="上传附件"
        :params="uploadParams"
        :span="12"
        @update-billsId="updateBillsId"
        ref="fileUpload"
        :isDelete="!id"
        :isSelect="!id"
      ></ab-upload2>
     </div>
    </el-form>

    <ab-footer>
      <template #button>
        <el-button type="primary" @click="printPdf" :loading="printLoading" v-if="dataForm.invoiceType === 1">打印合同</el-button>
        <el-button type="primary" :disabled="isEditInvoice" :loading="confirmLoading" @click="confirmSave" v-if="!id || dataForm.clientStatus === '01-1'">确 认</el-button>
        <el-button @click="backPage">返 回</el-button>
      </template>
    </ab-footer>
    <ab-preview :preview="preview" @handleClose="handleClose">
      <template #button>
        <el-button @click="preview.show = false">关 闭</el-button>
      </template>
    </ab-preview>
</div>
</template>

<script>
import calc from "../../utils/calculation";

export default {
  name: "my-invoice-detail",
  data() {
    return {
      detailData: {},
      isEditInvoice: false,
      dataForm: {},
      customerVo: {},
      tableData: [],
      btnLoading: false,
      tableLoading: false,
      id: '',
      // 开票
      columns: [
        {
          labels: "订单编号",
          props: "custOrderNo",
          widths: 140
        },
        {
          labels: "开票名称",
          props: "materialDesc",
          widths: 120
        },
        {
          labels: "规格型号",
          props: "model",
          widths: 120
        },
        {
          labels: "单位",
          props: "unitIdDesc",
          widths: 60
        },
        {
          labels: "数量",
          props: "invoiceCount",
          widths: 80
        },
        {
          labels: "不含税金额",
          props: "notTaxAmount",
          widths: 100,
          type: "money",
          align: "right"
        },
        {
          labels: "税额",
          props: "tax",
          widths: 100,
          type: "money",
          align: "right"
        },
        {
          labels: "价税合计",
          props: "taxAmount",
          widths: 100,
          type: "money",
          align: "right"
        },
        {
          labels: "税率(%)",
          props: "taxRate",
          widths: 80
        }
      ],
      tempBillId: null,
      uploadParams: {
        sourceBillId: '',
        sourceBillNumber: '',
        sourceBillType: 'DrawInvoice',
        billType: '',
        items: []
      },
      printLoading: false,
      confirmLoading: false,
      preview: {
        show: false,
        isView: false,
        isFooter: true,
        fileUrl: ''
      }
    };
  },
  watch: {
    "id"(val) {
      this.dataForm = {};
      this.customerVo = {};
      this.tableData = [];
      this.getDetailData(val);
    }
  },
  computed: {
      menuActiveName: {
        get() {
          return this.$store.state.common.menuActiveName
        },
        set(val) {
          this.$store.commit('common/updateMenuActiveName', val)
        },
      },
      mainTabs: {
        get() {
          return this.$store.state.common.mainTabs
        },
        set(val) {
          this.$store.commit('common/updateMainTabs', val)
        },
      },},
  mounted() {},
  created() {
    this.id = this.$route.query.id
    if(!this.$route.query.id) {
      console.log(this.$route.query.params, '==================');
      this.detailData = this.$route.query.params
    }
  },
  methods: {
    handleClose () {
      this.$emit('refresh')
    },
    //保存
    confirmSave() {
      let params = {}
      if (this.id) { // 已申请
        params = this.dataForm
        params.drawInvoiceEntryDtos = params.drawInvoiceEntryVos
        params.customerVo.billBankName= params.customerVo.billName
      } else {
        params = this.detailData.result
        params.drawInvoiceEntryDtos = this.detailData.drawInvoiceEntryVos
        params.customerVo= this.detailData.customerVo
        params.customerVo.billBankName= this.detailData.customerVo.billName
      }
      if (this.tempBillId) {
        params.tempBillId = this.tempBillId
      }
      this.confirmLoading = true
      this.$http({
        url: this.$http.adornUrl(
          window.SITE_CONFIG.contextPath +
            "/fms/client/drawInvoice/save"
        ),
        method: "post",
        data: params
      }).then(({ data }) => {
        this.confirmLoading = false
        if (data.code === "C0000") {
          this.$message({
            type: "success",
            message: data.message
          });
          this.$emit('refresh')
          if (data.extra) {
            this.$router.push({
              path: '/seal-list'
            })
            //window.open(data.extra)
            this.preview.isView = true
            this.preview.fileTitle = '销售合同'
            this.preview.fileUrl = data.extra
            this.preview.show = true
          }else{
            this.mainTabs.filter(item => item.name !== this.menuActiveName) // 删除
            this.$router.push({
              path: '/my-account-my-invoice-list',
              query: {
                activeName: 'already'
              }
            })
          }
        } else {
          this.$message({
            type: "error",
            message: data.message
          });
          return;
        }
      });
    },
    bankChange(data) {
      if (data && data.id) {
        this.customerVo.billBankId = data.id;
        this.customerVo.billBank = data.name;
      } else {
        this.customerVo.billBankId = "";
        this.customerVo.billBank = "";
      }
    },
    editInvoice() {
      let data = {
        billName: this.customerVo.billName,
        taxpayerCode: this.customerVo.taxpayerCode,
        billAddress: this.customerVo.billAddress,
        billTel: this.customerVo.billTel,
        billBankName: this.customerVo.billBank,
        billBankAcct: this.customerVo.billBankAcct,
        receiptInvoiceAddress: this.customerVo.receiptInvoiceAddress,
        receiptInvoicePerson: this.customerVo.receiptInvoicePerson,
        receiptInvoiceTel: this.customerVo.receiptInvoiceTel
      };
      if (this.isEditInvoice) {
        this.$http({
          url: this.$http.adornUrl(
            window.SITE_CONFIG.contextPath +
              "/bas/client/basCustomer/saveInvoiceTitle"
          ),
          method: "post",
          data
        }).then(({ data }) => {
          if (data.code === "C0000") {
            this.$message({
              type: "success",
              message: data.message
            });
            this.isEditInvoice = !this.isEditInvoice;
            this.getDetailData()
          } else {
            let obj = {'receiptInvoiceAddress': '收票地址', 'receiptInvoicePerson': '收票联系人', 'receiptInvoiceTel': '收票联系电话'}
            let message = data.essage
            for (const key in obj) {
                if(data.message && data.message.indexOf(key) != -1) {
                  message = `${obj[key]}值不能为空！`
                  this.$message({
                    type: "error",
                    message
                  });
                  return;
                }
              }
          }
        });
      }else{
          this.isEditInvoice = !this.isEditInvoice;
      }
    },
    getDetailData(id) {
      if (!id) {
        if(this.detailData.result) {
          this.tableData = this.detailData.drawInvoiceEntryVos;
          this.dataForm = this.detailData.result;
          this.customerVo = this.detailData.customerVo;
        }
        this.initUpload()
        return;
      }
      this.tableLoading = true;
      this.$get("/fms/drawInvoice/get", { id }).then(({ data }) => {
        if (data && data.code === "C0000") {
          let result = data.result || {};
          this.dataForm = result;
          this.customerVo = result.customerVo || {};
          if (result.invoiceTypeDesc && result.invoiceTypeDesc === "货值发票") {
            this.tableData = result.drawInvoiceEntryVos || [];
          } else {
            this.tableData = result.mergeVos || [];
          }
          this.initUpload()
        } else {
          this.$message.error(data.message);
        }
        this.tableLoading = false;
      });
    },

    // 导出
    exportFile() {
      console.log(this.detailData.result, this.detailData.customerVo);
      let params = {}
      let excelField = this.columns.map(e => e.props);
      if(this.detailData.result) {
        params.data= this.detailData.result
        params.data.mergeDtos= params.data.mergeVos
        params.data.drawInvoiceEntryDtos= params.data.drawInvoiceEntryVos
        params.data.customerVo= this.detailData.customerVo
        params.data.customerVo.billBankName= this.customerVo.billBank
        params.data.customerVo.id= null
      }else{
        params.mergeDtos = this.tableData
      }
        params.excelField= excelField
        if(this.id) {
        params.data= {id: this.id}
        }
      this.$post(
        "/fms/client/drawInvoice/deriveDrawInfo",
        params,
        this,
        "btnLoading"
      ).then(({ data }) => {
        if (data && data.code === "C0000") {
          // 创建隐藏的可下载链接
          var eleLink = document.createElement("a");
          eleLink.download = "";
          eleLink.target = "_blank";
          eleLink.style.display = "none";
          // 字符内容转变成blob地址
          eleLink.href = data.message;
          // 触发点击
          document.body.appendChild(eleLink);
          eleLink.click();
          // 然后移除
          document.body.removeChild(eleLink);
        } else {
          this.$message.error(data.message);
        }
      });
    },

    // 合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (
          ["invoiceCount", "notTaxAmount", "tax", "taxAmount"].includes(
            column.property
          )
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return calc.add(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          if (column.property !== "invoiceCount") {
            sums[index] = Vue.filter("formatMoney")(sums[index]);
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
      backListPage(path) {
        this.mainTabs = this.mainTabs.filter(
          (item) => item.name !== this.menuActiveName
        ) // 删除
        if (this.menuActiveName) {
          this.$router.push({ path })
        }
      },
    backPage() {
      this.backListPage('/my-account-my-invoice-list')
    },

    updateBillsId (tempBillId) {
      // 更新附件id
      this.tempBillId = tempBillId
    },

    initUpload () {
      // 初始化上传组件
      this.$set(this.uploadParams, 'sourceBillId', this.dataForm.id)
      this.$set(this.uploadParams, 'sourceBillNumber', this.dataForm.number)
      setTimeout(() => {
        let items = [
          {
            title: '销售合同',
            attachType: '010',
            required: !this.dataForm.hasFlow
          }
        ]
        this.$set(this.uploadParams, 'items', items)
      }, 500)
    },

    // 打印合同
    printPdf() {
      this.printLoading = true
      if (this.id) {
        this.$post('/fms/drawInvoice/printSalesContractPdf', { ids: [this.id] }).then(({ data }) => {
          if (data && data.code === "C0000") {
            this.$message({
              type: 'success',
              message: data.message
            })
            this.printLoading = false
            // this.windowOpenFile(data.result)
          }
        })
      } else {
        this.$post('/fms/client/drawInvoice/printPdf', { drawInvoicVo: this.detailData.result }).then(({ data }) => {
          if (data && data.code === "C0000") {
            this.$message({
              type: 'success',
              message: data.message
            })
            this.printLoading = false
            this.windowOpenFile(data.result)
          }
        })
      }
    },

    // 创建隐藏的可下载链接
    windowOpenFile(url) {
      // 创建隐藏的可下载链接
      var eleLink = document.createElement("a");
      eleLink.download = "";
      eleLink.target = "_blank";
      eleLink.style.display = "none";
      // 字符内容转变成blob地址
      eleLink.href = url;
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },

    // 立即处理
    doItNow() {
      this.$router.push({
        path: '/user-center-enterprise_information',
        query: {
          scroll: 1228
        }
      })
    //  this.backPage()
    }
  }
};
</script>

<style lang="scss">
.my-invoice-detail {
    .ab-file-upload2 {
      margin-top: 0!important;
      .file--upload2 {
        padding: 0 20px!important;
      }
      .detail_content {
      
        padding-bottom: 20px !important;
      }
    }
  .tips {
    margin: 10px 0;
    color: #f00;
    text-align: center;
  }
  .el-dialog__body {
    padding: 10px;
    color: #333;
  }
  .operat-btn {
    position: absolute;
    top: 1px;
    right: 10px;
  }
  .textarea-item {
    height: auto !important;
    margin-bottom: 0;
  }
  .el-textarea__inner {
    padding: 4px 8px;
    font-size: 12px;
    border-radius: 0;
    resize: none;
    // text-indent: 2em;
  }
}
</style>
